export class SetWidget {
    public getConfSession(): string | null {
        const uuidRegex = /[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}/i;
        const matchUrl = document.location.href.match(uuidRegex);

        if (matchUrl) {
            return matchUrl[0];
        }

        const matchHash = document.location.hash.match(uuidRegex);

        return matchHash ? matchHash[0] : null;
    }

    public getDiamondId(): string | null {
        const diamondRegex = /\/((gia|hrd|igi|rap|lab)([a-z0-9A-Z]{6,}))/i;
        const match = document.location.href.match(diamondRegex);

        if (match) {
            return match[1]
        } else {
            const diamondRegex = /\/((gia|hrd|igi|rap|lab)([a-z0-9A-Z]{6,}))/i;
            const match = document.location.hash.match(diamondRegex);
            return match ? match[1] : null;
        }
    }

    public getBasePath(): string {
        let baseUrl = "/"

        if (window.__CONFIGURATOR_PROPS__) {
            baseUrl = window.__CONFIGURATOR_PROPS__.baseUrl
        }
        return baseUrl;
    }



    public createPath(target: string, inputDiamondId: string | null = null): string {
        if (target != 'conf' && target != "diamond" && target != "diamondSearch" && target != "catalog") {
            return "";
        }

        const confSession = this.getConfSession();
        const diamondId = inputDiamondId || this.getDiamondId()

        if (target == 'conf' && confSession == null) {
            return this.getBasePath() + "";
        } else if (target == 'conf' && confSession != null) {
            return this.getBasePath() + "#/conf/" + confSession;
        } else if (target == 'diamond' && diamondId != null) {
            if (confSession != null) {
                return this.getBasePath() + confSession + "/diamonds/" + diamondId;
            } else {
                return this.getBasePath() + "diamonds/" + diamondId;
            }
        } else if (target == 'diamondSearch') {
            if (confSession != null) {
                return this.getBasePath() + confSession + "/diamonds/";
            } else {
                return this.getBasePath() + "diamonds/search/";
            }
        } else if (target === 'catalog') {
            if (diamondId != null) {
                return this.getBasePath() + "catalog#/diamond/" + diamondId;
            } else {
                return this.getBasePath() + "catalog";
            }
        }

        return ""
    }
}